/* DRIPSUPPLY — interacciones del home (sin dependencias) */
(function(){
  var d=document,w=window,H=d.documentElement;
  w.__DS=true;
  H.classList.remove('ds-fallback');
  var RM=w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s));}

  /* 1. Quitar del catalogo los productos que ya salieron arriba */
  var shown={};
  all('.ds-sel [data-pid], .ds-spot [data-pid]').forEach(function(e){shown[e.getAttribute('data-pid')]=1;});
  all('.ds-cat').forEach(function(sec){
    var left=0;
    all('.ds-grid [data-pid]',sec).forEach(function(e){if(shown[e.getAttribute('data-pid')]){e.parentNode.removeChild(e);}else{left++;}});
    all('[data-count]',sec).forEach(function(c){c.textContent=(left<10?'0':'')+left;});
    var n=0;all('.ds-grid .ds-card [data-idx]',sec).forEach(function(i){n++;i.textContent='N° '+(n<10?'0':'')+n;});
    if(!left){var g=sec.querySelector('.ds-grid');if(g)g.style.display='none';var em=sec.querySelector('.ds-cat__empty');if(em)em.hidden=false;}
  });

  /* 2. Aparicion al entrar en pantalla */
  var els=all('.ds [data-reveal]');
  if(RM||!('IntersectionObserver' in w)){els.forEach(function(e){e.classList.add('in');});}
  else{
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.12});
    els.forEach(function(e){io.observe(e);});
  }

  /* 3. Scroll horizontal fijado (solo desktop) */
  var hs=all('[data-hscroll]');
  function layout(){
    hs.forEach(function(s){
      var t=s.querySelector('.ds-track');if(!t)return;
      var on=!RM&&w.innerWidth>=990;
      s.classList.toggle('is-pinned',on);
      t.style.transform='';
      if(on){var dist=Math.max(0,t.scrollWidth-w.innerWidth);s._dist=dist;s.style.height=(w.innerHeight+dist)+'px';}
      else{s._dist=0;s.style.height='';}
    });
  }

  /* 4. Progreso de scroll -> variable CSS --p (0..1) */
  var pr=all('[data-progress]'),ticking=false;
  function frame(){
    ticking=false;
    var vh=w.innerHeight;
    d.body.classList.toggle('is-scrolled',(w.pageYOffset||H.scrollTop)>30);
    if(RM)return;
    pr.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.bottom<-vh||r.top>vh*2)return;
      var m=el.getAttribute('data-progress'),p;
      if(m==='exit'){p=-r.top/r.height;}
      else if(m==='view'){p=(vh-r.top)/(vh+r.height);}
      else{var tot=r.height-vh;p=tot>0?-r.top/tot:0;}
      p=p<0?0:(p>1?1:p);
      el.style.setProperty('--p',p.toFixed(4));
      if(el._dist){var t=el.querySelector('.ds-track');if(t)t.style.transform='translate3d('+(-p*el._dist).toFixed(1)+'px,0,0)';}
    });
  }
  function req(){if(!ticking){ticking=true;w.requestAnimationFrame(frame);}}
  layout();frame();
  w.addEventListener('scroll',req,{passive:true});
  var rt;w.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){layout();req();loadVideos();},120);});
  w.addEventListener('load',function(){layout();req();});

  /* 5. Selector de tallas del producto destacado */
  all('[data-ds-buy]').forEach(function(f){
    var inp=f.querySelector('input[name="id"]'),add=f.querySelector('[data-ds-add]'),lbl=f.querySelector('[data-ds-price]'),sel=f.querySelector('[data-ds-selected]'),wa=f.querySelector('[data-ds-wa]');
    all('[data-vid]',f).forEach(function(b){
      b.addEventListener('click',function(){
        if(b.disabled)return;
        all('[data-vid]',f).forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        if(inp)inp.value=b.getAttribute('data-vid');
        if(lbl&&b.getAttribute('data-price'))lbl.textContent=b.getAttribute('data-price');
        if(sel)sel.textContent=b.getAttribute('data-title');
        if(add)add.disabled=false;
        if(wa){var base=wa.getAttribute('data-base');wa.href=base+encodeURIComponent(' — Talla: '+b.getAttribute('data-title'));}
      });
    });
  });

  /* 6. Galeria del producto destacado */
  all('[data-ds-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var wrap=b.closest('.ds-spot__media');if(!wrap)return;
      var main=wrap.querySelector('[data-ds-main] img'),src=b.querySelector('img');
      if(main&&src){main.src=src.getAttribute('data-full');main.removeAttribute('srcset');}
      all('[data-ds-thumb]',wrap).forEach(function(x){x.setAttribute('aria-current','false');});
      b.setAttribute('aria-current','true');
    });
  });

  /* 7. Reloj de Bogota en el HUD */
  var clk=all('[data-ds-clock]');
  function tc(){try{var t=new Date().toLocaleTimeString('es-CO',{timeZone:'America/Bogota',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false});clk.forEach(function(c){c.textContent=t;});}catch(e){}}
  if(clk.length){tc();setInterval(tc,1000);}

  /* 8. Videos del hero: solo el que corresponde al tamaño de pantalla, nunca con ahorro de datos,
        y con reintentos (pestaña en segundo plano, primer toque en iPhone) */
  var active=[];
  function tryPlay(v){if(!v.paused)return;v.muted=true;var p=v.play&&v.play();if(p&&p.catch)p.catch(function(){});}
  function loadVideos(){
    active=[];
    all('[data-ds-video]').forEach(function(v){
      var mq=v.getAttribute('data-mq');
      if(mq&&w.matchMedia&&!w.matchMedia(mq).matches){try{v.pause();}catch(e){}return;}
      var c=navigator.connection;
      if(RM||(c&&(c.saveData||/(^|-)2g/.test(c.effectiveType||'')))){v.removeAttribute('autoplay');try{v.pause();}catch(e){}return;}
      var src=v.getAttribute('data-src');
      if(src&&!v.getAttribute('src')){v.setAttribute('src',src);v.addEventListener('canplay',function(){tryPlay(v);},{once:true});}
      active.push(v);
      tryPlay(v);
    });
  }
  loadVideos();
  d.addEventListener('visibilitychange',function(){if(d.visibilityState==='visible')active.forEach(tryPlay);});
  ['touchstart','scroll'].forEach(function(ev){w.addEventListener(ev,function once(){active.forEach(tryPlay);w.removeEventListener(ev,once);},{passive:true});});
})();
